import { Box, Checkbox, InfoIcon, Text } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext, ZIndexContext } from "./../../ricos-context";
const CheckboxWithInfoIcon = ({ checked, onChange, textContent, tooltipContent, dataHook }) => {
  const { t } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);
  return /* @__PURE__ */ React.createElement(Checkbox, { dataHook, size: "small", checked, onChange }, tooltipContent ? /* @__PURE__ */ React.createElement(Box, { verticalAlign: "middle", gap: "SP1" }, /* @__PURE__ */ React.createElement(Text, { size: "small" }, t(textContent)), /* @__PURE__ */ React.createElement(
    InfoIcon,
    {
      size: "small",
      content: t(tooltipContent),
      tooltipProps: {
        appendTo: (el) => Boolean(el.getAttribute("data-hook")?.includes("ricos-portal")),
        zIndex: zIndexService.getZIndex("TOOLTIP")
      }
    }
  )) : /* @__PURE__ */ React.createElement(Text, { size: "small" }, t(textContent)));
};
export {
  CheckboxWithInfoIcon
};
//# sourceMappingURL=checkbox-with-info-icon.js.map
